import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import SMSEchoRow from './smsEchoRow';
import SMSEchoBuilder from './smsEchoBuilder';
import { getDuration } from '../../../../../redux/thunks/durationThunk';
import { getCampaignEchos } from '../../../../../redux/thunks/smsCampaignThunk';
import { CustomButton } from '../../../../shared';
import { PlusIcon } from '../../../../../assets';

function SMSEchos(props) {
    const [createEcho, setCreateEcho] = useState(true);
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { campaign } = useSelector((state) => state.campaign);
    const { echos } = useSelector((state) => state.smsCampaign);

    useEffect(() => {
        dispatch(getDuration());
        dispatch(
            getCampaignEchos({
                companyId: company.id,
                campaignId: campaign.id,
            })
        );
    }, []);

    return (
        <Box>
            {echos.length > 0 && (
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {echos?.map((echo) => {
                                return (    
                                    <SMSEchoRow
                                        id={echo.id}
                                        name={echo.name}
                                        message={echo.message}
                                        duration={echo.duration}
                                        type={echo.engagement_enabled?.toString()}
                                    />
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            )}
            <Box className="pt-12px">
                {
                    !createEcho && (<Box className="border-1-gray-300 br-8px pt-12px">
                        <SMSEchoBuilder handleAfterEchoSave={() => setCreateEcho(true)}/>
                    </Box>)
                }
                <Box className="pt-12px">
                    <CustomButton
                        title="Echo"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<PlusIcon color="#FFFFFF" />}
                        handleClick={() => setCreateEcho(false)}
                    />
               </Box>
            </Box>
        </Box>
    );
}

export default SMSEchos;
